import R from 'ramda';
import className from 'classnames';

export const generateListClassNames = ({ isOpen }) =>
  className('filter__filters-section-wrapper', {
    open: isOpen,
  });

export const generateFilterItemClassNames = ({ isSelected, optionColor }) =>
  className('filter__filters-section-list-item', {
    'with-color': !!optionColor,
    selected: isSelected,
  });

export const generateFilterMainButtonClassNames = ({ isOpen }) =>
  className('filter__button bold', {
    'filter__button-main': !isOpen,
  });

export const generateIcon = ({ isOpen }) =>
  isOpen
    ? '/ccx-files/assets/chevron-down.svg'
    : '/ccx-files/assets/filter.svg';

export const generateButtonCrossIconSrc = ({ disabled }) =>
  disabled ? '/ccx-files/assets/cross-grey.svg' : '/ccx-files/assets/cross.svg';

export const findSelectedFilterItem = ({
  filterName,
  option,
  selectedFilters,
}) =>
  R.find(
    R.and(
      R.propEq('categoryName', filterName),
      R.propEq('optionName', R.prop('name', option))
    ),
    selectedFilters
  );
